<template>
  <div class="mb-14 absolute right-0 -z-10" style="width: 9.5vw; top: 220%">
    <img :src="commonStore.getImgUrl('shared', 'starGroupIconSeaBlueRight', 'svg')" />
  </div>

  <egg-description
    :eggImgObj="{ componentName: 'covid19', imgName: 'bivalentVaccine', imgFormat: 'svg', position: 'right' }"
    :isShowStarBackgroundRight="false"
    :isShowStarBackgroundLeft="false"
    label="covid19.selfPayingBiontechBivalentVaccine"
    labelColor="#1687A7"
    labelFontClassSize="text-5xl"
    textCustomStyle="margin:auto;text-align: center;"
    textMode="text"
    class="pb-24 pt-34"
  >
    <template #customSection> <button-util buttonType="button" bgColor="#603813" label="covid19.bookNow" buttonWidth="5vw" @click="routeTo('bivalentvaccine')" class="m-auto" /> </template>
  </egg-description>
</template>

<script setup lang="ts">
import { useCovid19Store } from "@/stores/covid19";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useCommonStore } from "@/stores/common";

const commonStore = useCommonStore();
const covid19Store = useCovid19Store();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>